$( document ).ready( function(){
	checkItemsInDropdownCart();
});

Shopify.onItemAdded = function(line_item) {
 Shopify.getCart();
}; 

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '#myModal .cart-body .cart-items');
};


Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
//   var formatMoney = "<span class='money'>${{amount}}</span>";
  
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          if (value.length) {
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }

              $('<div class="item-row"><div class="item-images"><img src="' + item.image + '" alt=""/></div><div class="item-description"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="remove"><a class="remove-all-single">Remove</a></span></div><div class="item-quality"><input type="number" class="quanity-fields" value="' + item.quantity + '"/><input type="hidden" id="variant-id" value="' + item.key + '"><p>' + Shopify.formatMoney(item.price) + ' * ' + item.quantity + '</p></div></div>').appendTo(table);
//               $('<div class="item"><figure class="cart_img"><img src="' + item.image + '" alt=""/></figure><div class="title_price"><h4 class="title"><a href="' + item.url + '">' + item.title + '</a></h4></div>').appendTo(table);
//               jQuery('<div class="cart-lists"><a href="' + item.url + '"><img src="' + item.image + '" alt=""/></a><div class="add-cart-text"><p><a href="' + item.url + '">' + item.title + '</a></p><p><span class="info-label"><span>'+jQuery(".cart_messages .price").text()+'</span><span>' + Shopify.formatMoney(item.price, formatMoney) + '</span> x '+jQuery(".cart_messages .qty").text()+'<span>' + item.quantity + '</span></span></p></div><div class="pro-close"><a class="remove" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" class="icon icon-delete"><i class="pe-7s-close"></i></a></div></div>').appendTo(table);
            });
          }
          else {
            jQuery(".header-cart .dropdown-toggle").css({"cursor": "default"});
          }
        }
      });
     	checkItemsInDropdownCart();
      $("#myModal").css('display','block');
      
    }
  }
  var cart_count = cart.item_count;
  var cart_amount = Shopify.formatMoney(cart.total_price);
  $('.item-count').html(cart_count);
  $('.total_price').html(cart_amount);
  
}


var checkItemsInDropdownCart = function() {
            if($('.cart-body .cart-items').children().length > 0) {
                $(".modal-content.no-items").hide();
                $(".modal-content.has-items").show();
            } 
              else {
                $(".modal-content.no-items").show();
                $(".modal-content.has-items").hide();
            }
}

    $('form[action="/cart/add"]').submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          dataType: 'json',
          data: $addToCartForm.serialize(),
          success: function(line_item) {
              if ((typeof callback) === 'function') {
                  callback(line_item);
              }
              else {
                  Shopify.onItemAdded(line_item);
              }
          },
         error: function(xhr, text) {
         $("#error-modal").css('display','block');
         }
    	});
     });
  
  $(document).on('change', 'input.quanity-fields', function() {

//   $("input.quanity-fields").change( function(){
    var value1 = $(this).val();
    var value2 = $(this).siblings().val().split(":");
        $.ajax({
          type: "post",
          url:'/cart/change.js',
          dataType: 'json',
          data:  'quantity='+value1+'&id='+value2[0],
          success: function(line_item) {
              if ((typeof callback) === 'function') {
                  callback(line_item);
              }
              else {
                  Shopify.onItemAdded(line_item);
              }
          },
         error: function(xhr, text) {
           alert('failed');
         }
    	});
  });
	
	$(document).on('click', '.remove-all-single', function() {
      var value2 = $(this).parents('.item-description').siblings().find('#variant-id').val().split(":");
        $.ajax({
          type: "post",
          url:'/cart/change.js',
          dataType: 'json',
          data:  'quantity='+0+'&id='+value2[0],
          success: function(line_item) {
              if ((typeof callback) === 'function') {
                  callback(line_item);
              }
              else {
                  Shopify.onItemAdded(line_item);
              }
          },
         error: function(xhr, text) {
           alert('failed');
         }
    	});
     });
